import {MeterTypeEnum} from 'common/proxies/enum-proxy';

export const precedence = [
  MeterTypeEnum.ELECTRICITY,
  MeterTypeEnum.PV,
  MeterTypeEnum.WATER,
  MeterTypeEnum.HEATING,
  MeterTypeEnum.COOLING,
  MeterTypeEnum.NATURAL_GAS,
];
